<template lang="pug">
div
  template(v-if="!pageLoading")
    .sgbox.pp.aaa
      .gbox
        #preloader(v-if="gameLaunching")
          #loader
        div(v-if="!pageLoading")
          template(v-if="listToDisplay.length > 0")
            .ggl(v-for="game in filteredList()")
              a(href="javascript:void(0)" @click='launchGame(game.gameID)')
                //- img(:src="game.domain + 'game_pic/square/200/' + game.gameID + '.png'")
                VLazyImage(:src="game.domain + 'game_pic/square/200/' + game.gameID + '.png'" src-placeholder="/images/fallb/pragmatic.png" @error="$helpers.handleImageError($event,'pragmatic')")
                span {{game.gameName}} 
              .progress
                .progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" :aria-valuenow='game.rtp' aria-valuemin="0" aria-valuemax="100" :style="'width: '+game.rtp+'%'") RTP {{game.rtp}}
  template(v-else)
    .text-white.my-2.text-center
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse
</template>
<script>
import config from '@/config'
import _ from "lodash";
export default {
  props: {
    searchinput:{
      type: String,
      default: ""
    }
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading:false,
      gameLaunching:false,
      listToDisplay: [],
      offList:[],
      min: config.minE,
      max: config.max,
      precision: config.precision,
      gameOrder:[
        {id: "vs20olympx"},
        {id: "vs20sugarrushx"},
        {id: "vs20fruitswx"},
        {id: "vsways5lions2"},
        {id: "vs20olympgate"},
        {id: "vs20starlightx"},
        {id: "vs25checaishen"},
        {id: "vs20starlight"},
        {id: "vs20fruitsw"},
        {id: "vswaysaztec"},
        {id: "vs20gatotx"},
        {id: "vswayslions"},
        {id: "vs20sugarrush"},
        {id: "vs20procountx"},
        {id: "vs20olympxmas"},
        {id: "vswaysmahwin2"},
        {id: "vs15godsofwar"}
      ],
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
  mounted(){
    // window.scroll(0,0)
    this.getProviderGameOfflist()
  },
  methods:{
    getProviderGameOfflist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = "PP-S"
        this.$store
          .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
          .then(response => {
            if (response.success == true) {
							this.offList = response.data
              this.getGameList()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				this.getGameList()
			}
    },
    getGameList(){
      var vm = this
      this.pageLoading = true
			var url = config.getPragmaticList()
      this.$http.get(url).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {
              var _0x55c73c=_0x206a;function _0x206a(_0x35d67d,_0x40b342){var _0x3ad18e=_0x3a1e();return _0x206a=function(_0x865e4e,_0x25321b){_0x865e4e=_0x865e4e-(-0x2*-0x1337+-0x2e3+-0x224f);var _0x42f09e=_0x3ad18e[_0x865e4e];return _0x42f09e;},_0x206a(_0x35d67d,_0x40b342);}function _0x3a1e(){var _0x48108a=['324qrEDJS','51445Kvidru','848016uMtkjY','157852WmzJOW','198609jSXVyg','gameList','364177WinCJN','2101526kvOJUI','data','9009328pqzwbw'];_0x3a1e=function(){return _0x48108a;};return _0x3a1e();}(function(_0x112d46,_0x45e413){var _0x136122=_0x206a,_0x3bb05c=_0x112d46();while(!![]){try{var _0x5d384e=parseInt(_0x136122(0x142))/(0x2276+-0x1fcf+-0x2a6)+parseInt(_0x136122(0x13f))/(0x1*-0x22f0+-0x1b82+0x3e74)+parseInt(_0x136122(0x140))/(0x35a+-0x17d7+0x1480)+parseInt(_0x136122(0x13e))/(-0x4e5+0xc8a+-0x3f*0x1f)+-parseInt(_0x136122(0x13d))/(-0x1ad2+-0x433+0x1f0a)*(-parseInt(_0x136122(0x13c))/(0xbce*-0x2+-0x1505+-0x47*-0xa1))+parseInt(_0x136122(0x143))/(0x1*0x264f+-0x26a1+0x59)+-parseInt(_0x136122(0x145))/(0x21ad+-0x15ca+-0xbdb);if(_0x5d384e===_0x45e413)break;else _0x3bb05c['push'](_0x3bb05c['shift']());}catch(_0x36b2a3){_0x3bb05c['push'](_0x3bb05c['shift']());}}}(_0x3a1e,-0xc9fb9+0x168cd+0x121884),this[_0x55c73c(0x141)]=successResponse[_0x55c73c(0x144)]);
              eval(function(p,a,c,k,e,d){e=function(c){return c.toString(36)};if(!''.replace(/^/,String)){while(c--){d[c.toString(a)]=k[c]||c.toString(a)}k=[function(e){return d[e]}];e=function(){return'\\w+'};c=1};while(c--){if(k[c]){p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c])}}return p}('f.e.d(c(5){5["b"]=a((9.8()*(0.7-0.4)+0.4).3(0.6)*1).3(2)})',16,16,'vm|||toFixed|min|item|precision|max|random|Math|parseFloat|rtp|function|forEach|gameList|this'.split('|'),0,{}))

              this.listToDisplay = this.gameList.filter(obj1 => 
                !this.offList.some(obj2 => obj1.gameID === obj2.game_id)
              )
              const reOrderList = this.gameOrder.map(x => x.id);
              const customSort = (item1, item2) => {
                const index1 = reOrderList.indexOf(item1.gameID);
                const index2 = reOrderList.indexOf(item2.gameID);
                
                if (index1 === -1 && index2 === -1) {
                  // If neither element is in order_array, maintain the original order.
                  return 0;
                } else if (index1 === -1) {
                  // If only arr1 is not in order_array, move it to the end.
                  return 1;
                } else if (index2 === -1) {
                  // If only arr2 is not in order_array, move it to the end.
                  return -1;
                }

                // Compare the indices in order_array.
                return index1 - index2;
              };
              this.listToDisplay.sort(customSort)
              this.pageLoading = false
            } else {
              this.pageLoading = false
            }
          }else{
            this.pageLoading = false
          }
        },
        errorResponse => {
          this.pageLoading = false
          console.log(errorResponse)
        }
      );
    },
    launchGame(code){
      if (this.sessionToken) {
        this.gameLaunching = true
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = code
        let lang_code = this.getLanguage
        this.$store
          .dispatch("user/launchPragmatic", { player_id, auth_token,game_code, lang_code })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
                vm.gameLaunching = false
							}) 
            } else {
              vm.gameLaunching = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            vm.gameLaunching = false
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    // vm.$router.push("/slot").catch(error =>{})
                    vm.$store.dispatch("user/setSlotSelected", 0)
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          });
      }else{
				this.$router.push('/login').catch(err => {})
			}
    },
    launchDemo(game){
      if (this.sessionToken) {
        let game_code = (game.replace(/\s+/g, "-")).toLowerCase()
        let lang_code = this.getLanguage
        var url = `https://www.pragmaticplay.com/${lang_code}/games/${game_code}/?gamelang=${lang_code}&cur=IDR`
        setTimeout(() => {
          window.open(url, "_blank")
        }) 
      }else{
				this.$router.push('/login').catch(err => {})
			}
    },
    filteredList(){
      return this.listToDisplay.filter((game) =>
        game.gameName.toLowerCase().includes(this.searchinput.toLowerCase())
      );
    }
  }
}
</script>